export const legendOptions = {
  width: 758,
  height: 30, // Default height of without multiple distributions
  margin: {
    bottom: 20,
    top: 5,
    right: 0,
    left: 0,
  },
  wrapper: 'svg',
  top: 0,
  left: 0,
  isMap: false,
  maxSplit: 4,
  distributions: 1,
  textPadding: {
    top: 15,
    left: 30,
  },
  rowSpacing: 10,
  font: {
    'font-size': '12px',
    'font-weight': 'bold',
    'font-family': 'Arial, Helvetica, sans-serif',
  },
};



// WEBPACK FOOTER //
// ../~/eslint-loader!./js/config/legend.js